<template>
  <span>
    <InfoBox item level="primary">
      <template v-slot:icon>
        <img :src="require('@ores/css-library/assets/img/icons/electricity.svg')" alt="electricity" />
      </template>
      <template>
        <h3 class="lib__text-uppercase">{{ $t('identification.smartMeter.eanCode') }}</h3>
        <p>{{ eanCode }}</p>
      </template>
    </InfoBox>
    <InfoBox item level="success">
      <template v-slot:icon>
        <div class="lib__tooltips lib__tooltips--top-left">
          <span>
            <i class="fas fa-map-marker-alt"></i>
          </span>
          <span class="lib__tooltips__data">{{ $t('identification.smartMeter.addressTooltip') }}</span>
        </div>
      </template>
      <template>
        <h3 class="lib__text-uppercase">{{ $t('identification.smartMeter.address') }}

        </h3>
        <p>{{ addressFromConsumption }} </p>
      </template>
    </InfoBox>
  </span>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { CheckEanSmartMeterResult } from '@/models'

@Component({
  name: 'identification-details'
})
export default class IdentificationDetails extends Vue {
  //#region [Props]
  @Prop({ type: String, required: true }) public readonly eanCode!: string
  @Prop({ type: Object, required: true }) public readonly eanResult!: CheckEanSmartMeterResult
  //#endregion

  //#region [Computed]
  private get addressFromConsumption() {
    const address = this.eanResult.consumptionAddress
    let str = address.streetName
    if (address.houseNumber) {
      str += ' ' + address.houseNumber
    }
    if (address.complement) {
      str += ' ' + address.complement
    }
    if (address.complementBox) {
      str += ' ' + address.complementBox
    }
    if (address.floorNumber) {
      str += ` (${this.$t(`identification.smartMeter.floor`).toString()}: ${address.floorNumber})`
    }
    str += ', ' + address.zipCode
    str += ' ' + address.cityName
    return str
  }

  //#endregion
}
</script>
